import * as React from 'react';
import { useSelector } from 'react-redux';

import { TabsComponent } from '../../../components/NewbuildingTiledCarousel/Tabs';
import { getNewbuildingTiledCarouselTabs } from '../../../selectors/newObject';
import { TTabsType } from '../../../types/newbuildingTiledCarousel';

interface ITabsProps {
  activeTab: number;
  onChange(activeTab: number, type: TTabsType): void;
}

export const Tabs = ({ activeTab, onChange }: ITabsProps) => {
  const tabs = useSelector(getNewbuildingTiledCarouselTabs);

  const lastTabValue = tabs[tabs.length - 1]['value'];

  return (
    <TabsComponent activeTab={activeTab > lastTabValue ? lastTabValue : activeTab} tabs={tabs} onChange={onChange} />
  );
};

Tabs.displayName = 'Tabs';
